import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { colors, TabLink } from '../../healtheraComponents'
import IconChevron from '../Icons/IconChevron'

/**
 * @deprecated Use TabNavbarV2
 */
const TabNavbar = ({ title, backLink, tabs, changeTabHandle }) => (
  <Wrapper>
    <BackLink to={backLink}>
      <IconChevronStyled />
    </BackLink>
    <Title>{title}</Title>
    {tabs.map(tabItem => (
      <TabLink
        active={tabItem.active.toString()}
        to="#"
        key={tabItem.label}
        onClick={() => changeTabHandle(tabItem.label)}
      >
        {tabItem.label}
      </TabLink>
    ))}
  </Wrapper>
)

export default TabNavbar;

export const Wrapper = styled.div`
  && {
    align-items: center;
    border-bottom: 1px solid ${colors.GRAY_LIGHT};
    display: flex;
    font-size: 20px;
    height: 70px;
    position: relative;
    width: 100%;
  }
`

export const Title = styled.div`
  && {
    font-weight: bold;
    margin-right: auto;
  }
`

export const BackLink = styled(Link)`
  && {
    padding: 10px;
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
  }
`

export const IconChevronStyled = styled(IconChevron)`
  && {
    display: block;
    fill: ${colors.GRAY_DARK};
    transform: scaleX(-1);
    width: 11px;
  }
`
